import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ActionButton from '../../../Components/Common/ActionButton';

const SubmitConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Submission',
  message,
  confirmLabel = 'Submit',
  isSubmitting = false,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
    centered
    className='border-0 rounded-4'
  >
    <ModalBody className='p-0'>
      <div className='text-center px-4 pt-5 pb-4'>
        <div
          className='bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4'
          style={{ width: '80px', height: '80px' }}
        >
          <i className='ri-folder-line fs-36 text-white'></i>
        </div>

        <h4 className='fw-bold text-dark mb-2'>
          {title || 'Confirm Invitation'}
        </h4>

        <p className='text-muted fs-14 px-3 mb-0'>
          {message ||
            'Are you sure you want to submit this invitation to Registered Supplier? This action cannot be undone.'}
        </p>
      </div>

      <div className='border-top d-flex flex-wrap gap-2 align-items-center justify-content-between p-3 bg-white rounded-bottom-4'>
        <ActionButton
          variant='secondary'
          icon='ri-close-line'
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </ActionButton>

        <ActionButton
          variant='primary'
          onClick={onConfirm}
          loading={isSubmitting}
          className='px-4 px-sm-5'
          style={{ minWidth: '160px', maxWidth: '100%' }}
        >
          {confirmLabel || 'Submit'}
        </ActionButton>
      </div>
    </ModalBody>
  </Modal>
);

export default SubmitConfirmModal;
